const checkin = {
	title: "Dashboard",
	no_upcoming_course: "Ingen nye kurs",
	certreg_id: "ID",
	duration: "Varighet",
	enrolled: "Påmeldte",
	students: "Elev",
	attendees: "Deltagere",
	did_not_meet: "Ikke møtt opp",
	did_not_meet_btn: "Ikke møtt opp",
	did_not_meet_confirm: "Elev har ikke møtt opp. Vil du fortsette?",
	check_in_btn: "Innsjekk",
	attendance_btn: "Oppmøte",
	enrol_title: "Innsjekk av {name}",
	sync_from_certreg: "Synkroniser fra XL3 database",
	certreg_user_not_exist: "Bruker finnes ikke i XL3 database",
	update_enrolemnt_from_certreg_confirm: "Vil du oppdatere informasjon for påmeldt fra XL3 database?",
};
export default checkin;